import React, { useState } from 'react';
import { FiFileText } from 'react-icons/fi';
import Swal from 'sweetalert2';
import styles from './ReportFieldsPopup.module.css';

// Mapeamento de chaves para nomes amigáveis
const fieldLabels = {
    tipoVeiculo: 'Tipo de Veículo',
    marca: 'Marca',
    modelo: 'Modelo',
    anoFabricacao: 'Ano Fabricação',
    anoModelo: 'Ano Modelo',
    placa: 'Placa',
    renavam: 'RENAVAM',
    chassi: 'Chassi',
    cor: 'Cor',
    potenciaMotor: 'Potência do Motor',
    motorista_nome: 'Motorista',
    motorista_cnh: 'Nº Habilitação (CNH)',
    quilometragem: 'Quilometragem',
    tipoCombustivel: 'Combustível',
    capacidadeTanque: 'Capacidade do Tanque',
    dataAquisicao: 'Data de Aquisição',
    valorAquisicao: 'Valor de Aquisição',
    codigo_cc: 'Código CC',
    observacoes: 'Observações'
};

const ReportFieldsPopup = ({ vehicle, onGenerate, onClose }) => {
    // Inicializa todos os campos como DESMARCADOS por padrão
    const [selectedFields, setSelectedFields] = useState(
        Object.keys(fieldLabels).reduce((acc, key) => {
            acc[key] = false;
            return acc;
        }, {})
    );

    const handleCheckboxChange = (field) => {
        setSelectedFields(prev => ({
            ...prev,
            [field]: !prev[field]
        }));
    };

    const handleGenerateClick = () => {
        const fieldsToInclude = Object.keys(selectedFields).filter(key => selectedFields[key]);

        // Validação para impedir relatório vazio
        if (fieldsToInclude.length === 0) {
            Swal.fire({
                title: 'Nenhum Campo Selecionado',
                text: 'Por favor, selecione pelo menos um campo para gerar o relatório.',
                icon: 'warning',
                confirmButtonColor: '#f59e0b',
                confirmButtonText: 'Entendido'
            });
            return;
        }

        onGenerate(fieldsToInclude);
        onClose();
    };

    const toggleSelectAll = (selectAll) => {
        setSelectedFields(
            Object.keys(fieldLabels).reduce((acc, key) => {
                acc[key] = selectAll;
                return acc;
            }, {})
        );
    };

    return (
        <div className={styles.popupOverlay}>
            <div className={styles.popupContent}>
                <header className={styles.popupHeader}>
                    <h2>Selecionar Campos para o Relatório</h2>
                    <button onClick={onClose} className={styles.closePopupBtn}>&times;</button>
                </header>
                <div className={styles.popupBody}>
                    <div className={styles.selectAllControls}>
                        <button onClick={() => toggleSelectAll(true)} className={styles.controlButton}>Marcar Todos</button>
                        <button onClick={() => toggleSelectAll(false)} className={styles.controlButton}>Desmarcar Todos</button>
                    </div>
                    <div className={styles.fieldsGrid}>
                        {Object.entries(fieldLabels).map(([key, label]) => (
                             (vehicle.hasOwnProperty(key) || (key === 'motorista_cnh' && vehicle.hasOwnProperty('motorista_nome'))) && (
                                <label key={key} className={styles.checkboxLabel}>
                                    <input
                                        type="checkbox"
                                        checked={!!selectedFields[key]}
                                        onChange={() => handleCheckboxChange(key)}
                                    />
                                    <span className={styles.checkboxCustom}></span>
                                    {label}
                                </label>
                            )
                        ))}
                    </div>
                </div>
                <footer className={styles.popupActions}>
                    <button type="button" className={`${styles.btn} ${styles.btnSecondary}`} onClick={onClose}>
                        Cancelar
                    </button>
                    <button type="button" className={`${styles.btn} ${styles.btnPrimary}`} onClick={handleGenerateClick}>
                        <FiFileText />
                        Gerar Relatório
                    </button>
                </footer>
            </div>
        </div>
    );
};

export default ReportFieldsPopup;
